import { Component, Input } from '@angular/core';
import { ConferenceStatDaysResource } from 'src/app/models/iconference.interface';
import { ExcelService } from 'src/app/services/common/excel.service';

@Component({
  selector: 'app-conf-stat-visit-days-table',
  templateUrl: './conf-stat-visit-days-table.component.html',
  styleUrl: './conf-stat-visit-days-table.component.css'
})
export class ConfStatVisitDaysTableComponent {
  @Input() data: ConferenceStatDaysResource[] = [];

  constructor(
    private _excel: ExcelService,
  ) {
  }
  onExcelDays(data: ConferenceStatDaysResource[]) {
    this._excel.exportExcel(
      "Посещаемость по дням",
      data,
      [],
      ["День", "Зарегистр.", "Прибыло", "Отметилось"]
    );
  }


}

